import { getAgentApiHost } from "@/lib/agent-api-host";

/**
 * Shared configuration utilities for OpenAPI clients
 */

/**
 * Returns the Shop Agent API base URL
 * Server-side uses environment variable, client-side can use proxy or direct connection
 */
export function shopAgentUrl(): string {
  return getAgentApiHost();
}

/**
 * Returns the Ingest API base URL
 * Server-side uses environment variable, client-side can use proxy or direct connection
 */
export function ingestUrl(): string {
  return process.env.NEXT_PUBLIC_INGEST_API_URL || "http://localhost:8009";
}
